import React from 'react'
import Nav from '../Components/Navbar/Nav'
import Footer from '../Components/Footer/Footer'

const Toolskit = () => {
  return (
    <div>
      <Nav/>
      <Footer/>
    </div>
  )
}

export default Toolskit
